import moment from 'moment'

export const parseMedicationDate = (date?: string) => (date ? moment(new Date(date)).utc().format('MM-DD-YYYY') : null)

export const getMedicationDateTimestamp = (date?: string) => (date ? moment(date, 'MM-DD-YYYY').valueOf() : null)

export const formatMedicationDateToApi = (date?: string) =>
  date ? moment(getMedicationDateTimestamp(date)).format('YYYY-MM-DD') : null
